import React from 'react';
import {withRouter} from 'react-router-dom';


import VisuelHarmonieCuisine1 from "../visuels/harmonies/cuisine/harmonie-1.jpg";
import VisuelHarmonieCuisine2 from "../visuels/harmonies/cuisine/harmonie-2.jpg";
import VisuelHarmonieCuisine3 from "../visuels/harmonies/cuisine/harmonie-3.jpg";
import VisuelHarmonieCuisine4 from "../visuels/harmonies/cuisine/harmonie-4.jpg";
import VisuelHarmonieCuisine5 from "../visuels/harmonies/cuisine/harmonie-5.jpg";
import VisuelHarmonieCuisine6 from "../visuels/harmonies/cuisine/harmonie-6.jpg";
import VisuelHarmonieCuisine7 from "../visuels/harmonies/cuisine/harmonie-7.jpg";
import VisuelHarmonieCuisine8 from "../visuels/harmonies/cuisine/harmonie-8.jpg";
import VisuelHarmonieCuisine9 from "../visuels/harmonies/cuisine/harmonie-9.jpg";
import VisuelHarmonieCuisine10 from "../visuels/harmonies/cuisine/harmonie-10.jpg";


import VisuelHarmonieSdb1 from "../visuels/harmonies/sdb/Vue-SDB_01-Rose-nenuphar.jpg";
import VisuelHarmonieSdb2 from "../visuels/harmonies/sdb/Vue-SDB_02-Rose-blush.jpg";
import VisuelHarmonieSdb3 from "../visuels/harmonies/sdb/Vue-SDB_03-Roche-Lin-2.jpg";
import VisuelHarmonieSdb4 from "../visuels/harmonies/sdb/Vue-SDB_04-Bleu-profond-2.jpg";
import VisuelHarmonieSdb5 from "../visuels/harmonies/sdb/Vue-SDB_05-Bleu-ecume-bleu-profond-2.jpg";
import VisuelHarmonieSdb6 from "../visuels/harmonies/sdb/Vue-SDB_06-Bleu-Lagon-Bleu-ecume.jpg";
import VisuelHarmonieSdb7 from "../visuels/harmonies/sdb/Vue-SDB_07-Aigue-marine-bleu-ecume-2.jpg";
import VisuelHarmonieSdb8 from "../visuels/harmonies/sdb/Vue-SDB_08-Manganese-bleu-lagon-2.jpg";
import VisuelHarmonieSdb9 from "../visuels/harmonies/sdb/Vue-SDB_09-Gris-perle-manganese.jpg";

class AffichageProduitsSelectionnes extends React.Component {

    visuel = "";

    redirectToHome = () => {
        const {history} = this.props;
        if (history) history.push('/');
    };

    redirectToInfo = () => {
        const { history } = this.props;
        if(history) history.push('/infos');
    }


    redirectToBack = () => {
        const {history} = this.props;
        if (history) history.goBack();
    };

     getCorrectTextColor =(hex) => {

        /*
        From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast

        Color brightness is determined by the following formula:
        ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

  I know this could be more compact, but I think this is easier to read/explain.

        */

        var threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

         var hRed = hexToR(hex);
         var hGreen = hexToG(hex);
         var hBlue = hexToB(hex);


        function hexToR(h) {return parseInt((cutHex(h)).substring(0,2),16)}
        function hexToG(h) {return parseInt((cutHex(h)).substring(2,4),16)}
        function hexToB(h) {return parseInt((cutHex(h)).substring(4,6),16)}
        function cutHex(h) {return (h.charAt(0)=="#") ? h.substring(1,7):h}

         var cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
        if (cBrightness > threshold){return "#000000";} else { return "#ffffff";}
    }





    componentDidMount() {
    }

    render() {
        const {params} = this.props.match;
        this.produits = this.props.produits;
        const produits =  this.produits.map((produit,index) =>
            <div className="visualiseur-produit" key={index}>
                <div className="visualiseur-produit-bg" style={{backgroundColor: produit.nuance.hexa}}>
                    <span className="visualiseur-produit-categorie" style={{color: this.getCorrectTextColor(produit.nuance.hexa)}}>{produit.nom}</span>
                    <span className="visualiseur-produit-couleur" style={{color: this.getCorrectTextColor(produit.nuance.hexa)}}> { produit.nuance.nom}</span>
                </div>
                <img onClick={() =>
                    this.props.affichageProduit(produit)
                        } key={index} src={ process.env.PUBLIC_URL + "/Visualiseur/lm/produits/"  + produit.nuance.minos_2l + ".PNG" } className="visualiseur-produit-photo"/>
            </div>
        );
        return (
            <div>
                {produits}

            </div>);
    }

}

export default withRouter(AffichageProduitsSelectionnes);